import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface BulkInviteState {
	unknownEmailsByIdentity: Record<string, string[]>;
}

const initialState: BulkInviteState = { unknownEmailsByIdentity: {} };

export const bulkInviteIdentityKey = (tenantId: string, accountEmail: string): string =>
	JSON.stringify([tenantId, accountEmail.trim().toLowerCase()]);

const bulkInviteSlice = createSlice({
	initialState,
	name: "bulkInvite",
	reducers: {
		holdUnknownBulkInvites: (
			state,
			{ payload }: PayloadAction<{ accountEmail: string; emails: string[]; tenantId: string }>
		) => {
			const key = bulkInviteIdentityKey(payload.tenantId, payload.accountEmail);
			state.unknownEmailsByIdentity[key] = [
				...new Set([
					...(state.unknownEmailsByIdentity[key] ?? []),
					...payload.emails.map((email) => email.trim().toLowerCase())
				])
			];
		}
	}
});

export const { holdUnknownBulkInvites } = bulkInviteSlice.actions;

export default bulkInviteSlice.reducer;
